/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const GetMyCalendarBranchMyCalendarParams = zod.object({
  "date": zod.coerce.date().optional()
})

export type GetMyCalendarBranchMyCalendarParams = zod.input<typeof GetMyCalendarBranchMyCalendarParams>;
export type GetMyCalendarBranchMyCalendarParamsOutput = zod.output<typeof GetMyCalendarBranchMyCalendarParams>;
